import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const EMAIL_SCHEMA_FIELD_NAME = "email";

export const getEmailFormFieldSchema = (label = i18n("EmailFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .lowercase()
    .when({
      is: (exists) => !!exists,
      then: yup.string().validEmail(),
    })
    .label(label.toLowerCase());
